import { createAction } from 'redux-actions';

const types = {
  HOTEL_TAP_EVENT: 'HOTEL_TAP_EVENT',
  HOTEL_VIEW_EVENT: 'HOTEL_VIEW_EVENT',
  HOTEL_SEARCH_WIDGET_SUBMIT_SEARCH: 'HOTEL_SEARCH_WIDGET_SUBMIT_SEARCH',
  HOTEL_SEARCH_INITIATED: 'HOTEL_SEARCH_INITIATED',
  HOTEL_SELECT_HOTEL_EVENT: 'HOTEL_SELECT_HOTEL_EVENT',
  HOTEL_SELECT_ROOM_EVENT: 'HOTEL_SELECT_ROOM_EVENT',
  HOTEL_VIEW_ROOM_EVENT: 'HOTEL_VIEW_ROOM_EVENT',
  HOTEL_FIELD_LEFT_EMPTY: 'HOTEL_FIELD_LEFT_EMPTY',
  HOTEL_GUEST_DETAIL_SUMMIT: 'HOTEL_GUEST_DETAIL_SUMMIT',
  HOTEL_GUEST_DETAIL_LOADED: 'HOTEL_GUEST_DETAIL_LOADED',
  HOTEL_PAYMENT_INITIATED: 'HOTEL_PAYMENT_INITIATED',
  HOTEL_SELECT_DEFAULT_HOTEL_EVENT: 'HOTEL_SELECT_DEFAULT_HOTEL_EVENT',
  HOTEL_SELECT_PRICE_FILTER: 'HOTEL_SELECT_PRICE_FILTER',
  HOTEL_ROOM_SELECT_MAP: 'HOTEL_ROOM_SELECT_MAP',
  HOTEL_GUEST_DETAIL_LOADED: 'HOTEL_GUEST_DETAIL_LOADED',

  // Ecommerce events
  HOTEL_VIEW_ITEM_LIST: 'HOTEL_VIEW_ITEM_LIST',
  HOTEL_SELECT_ITEM: 'HOTEL_SELECT_ITEM',
  HOTEL_ADD_TO_CART: 'HOTEL_ADD_TO_CARD',
  HOTEL_BEGIN_CHECKOUT: 'HOTEL_BEGIN_CHECKOUT',
  HOTEL_ADD_PAYMENT_INFO: 'HOTEL_ADD_PAYMENT_INFO',
  HOTEL_PURCHASE_EVENT: 'HOTEL_PURCHASE',
  HOTEL_DETAILED_REVIEWS: 'HOTEL_DETAILED_REVIEW',
  HOTEL_DETAILED_REVIEWS_PAGINATION: 'HOTEL_DETAILED_REVIEWS_PAGINATION',
  HOTEL_REVIEWS_CLICK: 'HOTEL_REVIEWS_CLICK',
  HOTEL_SELECT_ROOM_FILTER: 'HOTEL_SELECT_ROOM_FILTER',

  HOTEL_TRACK_STATUS_CODE: 'HOTEL_TRACK_STATUS_CODE',
  HOTEL_TRACK_RECEIVE_API_RESPONSE: 'HOTEL_TRACK_RECEIVE_API_RESPONSE',
};

const actionCreators = {
  trackTapEvent: createAction(types.HOTEL_TAP_EVENT),
  trackViewEvent: createAction(types.HOTEL_VIEW_EVENT),
  trackSearchHotelSubmit: createAction(types.HOTEL_SEARCH_WIDGET_SUBMIT_SEARCH),
  trackSearchInitiated: createAction(types.HOTEL_SEARCH_INITIATED),
  trackSelectHotelEvent: createAction(types.HOTEL_SELECT_HOTEL_EVENT),
  trackSelectDefaultHotelEvent: createAction(
    types.HOTEL_SELECT_DEFAULT_HOTEL_EVENT
  ),
  trackViewRoomEvent: createAction(types.HOTEL_VIEW_ROOM_EVENT),
  trakcSelectRoomEvent: createAction(types.HOTEL_SELECT_ROOM_EVENT),
  trackFieldLeftEmpty: createAction(types.HOTEL_FIELD_LEFT_EMPTY),
  trackGuestDetailSummit: createAction(types.HOTEL_GUEST_DETAIL_SUMMIT),
  trackGuestDetailLoader: createAction(types.HOTEL_GUEST_DETAIL_LOADED),
  trackPaymentInitiated: createAction(types.HOTEL_PAYMENT_INITIATED),
  // Ecomerce events
  trackViewItemList: createAction(types.HOTEL_VIEW_ITEM_LIST),
  trackSelectItem: createAction(types.HOTEL_SELECT_ITEM),
  trackAddToCart: createAction(types.HOTEL_ADD_TO_CART),
  trackBeginCheckout: createAction(types.HOTEL_BEGIN_CHECKOUT),
  trackAddPaymentInfo: createAction(types.HOTEL_ADD_PAYMENT_INFO),
  trackPurchaseEvent: createAction(types.HOTEL_PURCHASE_EVENT),
  trackClickOnPriceFilterMobile: createAction(types.HOTEL_SELECT_PRICE_FILTER),
  trackRoomSelectOnMap: createAction(types.HOTEL_ROOM_SELECT_MAP),
  trackHotelDetailedReview: createAction(types.HOTEL_DETAILED_REVIEWS),
  trackHotelDetailedReviewPagination: createAction(
    types.HOTEL_DETAILED_REVIEWS_PAGINATION
  ),
  trackHotelReviewClick: createAction(types.HOTEL_REVIEWS_CLICK),
  trackHotelSelectRoomFilterEvent: createAction(types.HOTEL_SELECT_ROOM_FILTER),
  trackStatusCode: createAction(types.HOTEL_TRACK_STATUS_CODE),
  trackReceiveApiResponse: createAction(types.HOTEL_TRACK_RECEIVE_API_RESPONSE),
};

export { types, actionCreators };
